export enum ApiPath {
    INSTALLATION_GENERIC_LINE_CHART_QUERY = "installation/generic_line_chart_query/",
    INSTALLATION_TOTAL_KG_CAPTURED = "installation/total_kg_captured/",
    INSTALLATION_TREE_EQUIV_AND_MAX_RATE = "installation/tree_equivalent_and_max_rate/",
    INSTALLATION_REFRIGERANT_CONTINUOUS_ACTIVE_POWER = "installation/refrigerant/continuous_active_power/",
    INSTALLATION_REFRIGERANT_ON_PERIODS = "installation/refrigerant/on_periods/",
    INSTALLATION_REFRIGERANT_ANALYZE_ON_PERIOD_TEMPERATURE_ANOMALIES = "installation/refrigerant/analyze_on_period_temperature_anomalies/",
    INSTALLATION_REFRIGERANT_AGGREGATED_ENERGY = "installation/refrigerant/aggregated_energy/",
    INSTALLATION_REFRIGERANT_ESTIMATE_PRESSURE = "installation/refrigerant/estimate_pressure/",
    EQUIPMENT_TOTAL_POWER = "equipment/query/total_power/",
    EQUIPMENT_TOTAL_ENERGY = "equipment/query/total_energy/",
    EQUIPMENT_TOTAL_CURRENT = "equipment/query/total_current/",
    EQUIPMENT_TOTAL_VOLTAGE = "equipment/query/total_voltage/",
}
